import { ImageKit, Typography } from "@aph/ui-lib-humanx";
import React, { useState } from "react";
import styles from "./ProfileLink.module.scss";

interface ProfileLinkProps {
  onClick?: (e?: any) => void;
  handleSubMenuClick?: (d: { menuItem: any; title: string; index: number }) => void;
  title?: string;
  subTitle?: string;
  titleIconClassName?: string;
  titleIconUrl?: string;
  className?: string;
  subMenu?: { label: string; onClick: () => void }[];
  IconSize?: string;
}

const ProfileLink: React.FC<ProfileLinkProps> = (props) => {
  const {
    onClick,
    title,
    subTitle,
    titleIconClassName,
    className = "",
    subMenu = [],
    titleIconUrl,
    IconSize,
    handleSubMenuClick,
  } = props;

  const [isOpenSunMenu, setIsOpenSunMenu] = useState<boolean>(false);

  const openSubMenu = () => {
    setIsOpenSunMenu(!isOpenSunMenu);
  };

  return (
    <div className={className}>
      <div className={`${styles.linkRoot}`} onClick={onClick}>
        <div className={styles.leftBx}>
          {titleIconUrl ? (
            <span className={styles.iconBx}>
              <ImageKit className={styles.img} src={titleIconUrl} alt="profileIcon" width={36} height={36} />
            </span>
          ) : (
            <span className={`${titleIconClassName} ${styles.titleIcon}`} style={{ fontSize: IconSize }} />
          )}
          <div>
            {title && (
              <Typography component="h3" className={styles.title}>
                {title}
              </Typography>
            )}
            {subTitle && <Typography className={styles.subTitle}>{subTitle}</Typography>}
          </div>
        </div>
        <div className={styles.rightArrow} onClick={openSubMenu}>
          <span className={`icon-icon-left ${styles.rightIco}`} />
        </div>
      </div>
      {isOpenSunMenu && subMenu?.length >= 1 && (
        <ul className={styles.subMenuRoot}>
          {subMenu.map((menuItem, index) => (
            <li
              key={`menu-#${index}`}
              className={styles.list}
              onClick={() => handleSubMenuClick({ menuItem, title, index })}
            >
              {menuItem?.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ProfileLink;
